import SpriteSymbol from "../../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.store/svg-sprite-loader@5.2.1/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-CheckOut",
  "use": "icon-CheckOut-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-CheckOut\"><path fill=\"#e16531\" d=\"M889.344 41.984H133.12L0 299.52v682.496h1024v-686.08L889.344 41.984z m-378.88 411.136l199.68 196.096h-133.12v228.864h-133.12v-228.864h-133.12l199.68-196.096zM133.12 308.224l88.576-177.664h578.56l88.576 177.664H133.12z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol